import { Pipe, PipeTransform, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { translate } from './i18n/index';

@Injectable()
export class I18nService {
    defaultLang: string;
    langData: any;
    constructor() {
        this.defaultLang = localStorage.getItem('languageCode');
        if (!this.defaultLang) {
            this.langData = translate['zh-CHS'];
        } else {
            this.langData = translate[this.defaultLang];
        }
    }

    getValue(name: string): any {
        if (!name) {
            return '';
        }
        let resultVal = '';
        if (name.indexOf('.') === -1) {
            resultVal = this.langData[name];
        } else {
            resultVal = name.split('.').reduce((obj, key) => {
                if (obj) {
                    return obj[key];
                } else {
                    return null;
                }
            }, this.langData);
        }
        return resultVal;
    }
}
